import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextRegular } from 'UiKit/typography';
import ProgressBar from 'UiKit/progress-bar';

import styles from './styles.module.css';

const ProgressUploadFile = () => {
  const { t } = useTranslation('schedule');
  return (
    <Box>
      <Flex gap={'8px'} flexDirection={'column'}>
        <Box className={styles['form-upload__loading-text-container']}>
          <TextRegular className={styles['form-upload__loading-text']}>{t('uploadLoadingText')}</TextRegular>
        </Box>
        <ProgressBar />
        <TextRegular>{t('uploadLoadingSubText')}</TextRegular>
      </Flex>
    </Box>
  );
};

export default ProgressUploadFile;
